<template>
  <MonitorWrapper>
    <div class="cd602-container">
      <div class="chart-wrap" v-if="pageState === 2">
        <template v-for="item in charts">
          <HTChart
            :key="item.prop"
            :data="data"
            :prop="item.prop"
            :title="item.name"
            :colors="item.colors"
          />
        </template>
      </div>
      <div v-else class="hint">{{ pageStateText }}</div>
    </div>
  </MonitorWrapper>
</template>

<script>
import monitorMixin from '@/mixins/monitorMixin';

import Chart from './components/chart.vue';

import { isEmpty, isObject } from '@/utils/is';

export default {
  name: 'CD602',
  mixins: [monitorMixin],
  components: { HTChart: Chart },
  data() {
    return {
      pageState: 0,
      data: [],
      charts: [
        {
          name: '异味MOS传感器数据',
          prop: 's1Value',
          colors: ['#992222']
        },
        {
          name: '费加罗MOS传感器数据',
          prop: 's2Value',
          colors: ['#992293']
        },
        {
          name: '温度',
          prop: 'temp',
          colors: ['#009533']
        },
        {
          name: '湿度',
          prop: 'humidity',
          colors: ['#2222f0']
        }
      ]
    };
  },
  computed: {
    pageStateText() {
      const dict = {
        0: '数据加载中...',
        1: '暂无数据'
      };
      return dict[this.pageState];
    }
  },
  methods: {
    updateHisData(res) {
      try {
        const { data } = res;

        const { deviceDatas } = data;

        const details = deviceDatas.map(e => {
          const { cd602Mod } = e?.mods || {};

          return {
            beginTime: e.beginTime,
            s1Value: cd602Mod.s1Value || 0,
            s2Value: cd602Mod.s2Value || 0,
            temp: cd602Mod.temp || 0,
            humidity: cd602Mod.humidity || 0
          };
        });

        this.pageState = 2;

        this.data.push(...details);
      } catch (error) {
        console.error(error);
      }
    },
    updateData(res) {
      try {
        if (this.isHisDetail) return;

        const { cd602Mod } = res?.mods || {};

        if (!isObject(cd602Mod) || isEmpty(cd602Mod)) {
          this.pageState = 1;
          return;
        }

        this.pageState = 2;

        this.data.push({
          beginTime: res.beginTime,
          s1Value: cd602Mod.s1Value,
          s2Value: cd602Mod.s2Value,
          temp: cd602Mod.temp,
          humidity: cd602Mod.humidity
        });

        if (this.data.length > 100) {
          this.data.shift();
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="scss">
.cd602-container {
  width: 100%;
  height: 100%;

  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .chart-wrap {
    width: 100%;
    height: 100%;

    display: flex;
    flex-wrap: wrap;

    & > div {
      width: 50%;
      height: 50%;
    }
  }
}
</style>
